var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200,51.8v34.6c-1.3,5.5-4.2,10.6-8.5,14.8c-6,5.8-14.1,9-22.7,9H115V99.6c0-4.5-3.6-8.1-8.1-8.1H93.1 c-4.5,0-8.1,3.6-8.1,8.1v10.5H31.2c-8.6,0-16.6-3.2-22.7-9C4.2,97.1,1.3,92,0,86.4V51.8c0-7.5,6.1-13.6,13.6-13.6h172.9 C193.9,38.2,200,44.3,200,51.8z M106.9,128.8c0.7,0,1.3-0.6,1.3-1.3V117v-6.8V99.6c0-0.7-0.6-1.3-1.3-1.3H93.1 c-0.7,0-1.3,0.6-1.3,1.3v10.5v6.8v10.5c0,0.7,0.6,1.3,1.3,1.3H106.9z M196.2,106.1c-7.3,7-17,10.9-27.4,10.9H115v10.5 c0,4.4-3.6,8.1-8.1,8.1H93.1c-4.5,0-8.1-3.6-8.1-8.1V117H31.2c-10.3,0-20-3.9-27.4-10.9c-1.4-1.3-2.7-2.8-3.8-4.2v73.5 c0,7.5,6.1,13.6,13.6,13.6h172.9c7.5,0,13.6-6.1,13.6-13.6v-73.5C198.9,103.3,197.6,104.7,196.2,106.1z M131.3,15.1 c-2.7-2.7-6.1-4-9.6-4H78.3c-3.5,0-7,1.3-9.6,4c-2.6,2.6-4,6.1-4,9.6v6.8h11.5v-6.8c0-0.4,0.1-0.9,0.6-1.4c0.5-0.5,1.1-0.6,1.4-0.6 h43.4c0.4,0,0.9,0.1,1.4,0.6c0.5,0.5,0.6,1.1,0.6,1.4v6.8h11.5v-6.8C135.3,21.2,133.9,17.7,131.3,15.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobManagement);
export default __webpack_public_path__ + "static/media/job-management.04cb32f82b1ddce3fb53106347583260.svg";
export { ForwardRef as ReactComponent };